import { combineReducers } from 'redux'
import * as CONSTANT from '../util/constants'
import { getNearestStations } from '../util/stations'
import { normalizeMetarData } from '../util/avwx'

export const geolocation = (state = {
  isFetching: false,
  lat: undefined,
  long: undefined,
  updatedAt: undefined
}, action) => {
  switch(action.type) {
    case CONSTANT.REQUEST_GEOLOCATION:
      return Object.assign({}, state, {
        isFetching: true
      })
    case CONSTANT.REQUEST_GEOLOCATION_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        lat: action.pos.coords.latitude,
        long: action.pos.coords.longitude,
        updatedAt: action.updatedAt
      })
    case CONSTANT.REQUEST_GEOLOCATION_FAILURE:
      return Object.assign({}, state, {
        isFetching: false
      })
    default:
      return state
  }
}

const defaultMetarState = {
  altimeter: undefined,
  bearing: undefined,
  clouds: [],
  dewpoint: undefined,
  distance: undefined,
  error: undefined,
  flightRules: undefined,
  icao: undefined,
  isFetching: false,
  name: undefined,
  rawReport: undefined,
  remarks: undefined,
  runwayVisibility: [],
  temperature: undefined,
  time: undefined,
  updatedAt: undefined,
  weather: undefined,
  visibility: undefined,
  windDirection: undefined,
  windGust: undefined,
  windSpeed: undefined,
  windVariableDirection: undefined
}

export const metarLocation = (state = {
  lat: undefined,
  long: undefined,
  name: undefined,
  initialMetarCount: CONSTANT.INITIAL_METAR_COUNT,
  metars: [],
  nearestStations: [],
  updatedAt: undefined
}, action) => {
  switch(action.type) {
    case CONSTANT.UPDATE_METAR_LOCATION:
      const nearestStations = getNearestStations(action.lat, action.long)
      const nearestMetars = nearestStations.slice(0, state.initialMetarCount)
      return Object.assign({}, state, {
        lat: action.lat,
        long: action.long,
        name: action.name,
        metars: nearestMetars.map(rec => Object.assign({}, defaultMetarState, rec)),
        nearestStations,
        updatedAt: action.updatedAt
      })
    default:
      return Object.assign({}, state, {
        metars: state.metars.map(rec => metar(rec, action))
      })
  }
}

const metar = (state = defaultMetarState, action) => {
  switch(action.type) {
    case CONSTANT.UPDATE_METAR:
      if(state.icao === action.icao) {
        return Object.assign({}, state, {
          isFetching: true
        })
      }
      return state
    case CONSTANT.UPDATE_METAR_SUCCESS:
      if(state.icao === action.icao) {
        return Object.assign({}, state, normalizeMetarData(action.data), {
          error: undefined,
          isFetching: false,
          updatedAt: action.updatedAt
        })
      }
      return state
    case CONSTANT.UPDATE_METAR_FAILURE:
      if(state.icao === action.icao) {
        return Object.assign({}, state, {
          error: action.error,
          isFetching: false,
          updatedAt: action.updatedAt
        })
      }
      return state
    default:
      return state
  }
}

export const ephemeralMetars = (state = [], action) => {
  switch(action.type) {
    case CONSTANT.ADD_EPHEMERAL_METAR:
      return [
        ...state,
        Object.assign({}, defaultMetarState, {
          icao: action.icao,
          name: action.name
        })]
    default:
      return state.map(rec => metar(rec, action))
  }
}

const rootReducer = combineReducers({
  geolocation,
  metarLocation,
  ephemeralMetars
})

export default rootReducer



// WEBPACK FOOTER //
// ./src/reducers/reducers.js